export default __webpack_public_path__ + "static/media/weather.94920c66.png";